// Packages
import { useLocation } from 'react-router-dom';
// Custom Hooks
import { useBreakpoint } from 'customHooks';
// Routes
import { ROUTES } from 'router/routes';

const getCompanyFreePath = (path: string) => path.split('/').slice(2).join('/');

// Same cut-off as the phone menu in the header: below `lg` the app keeps its phone navigation.
// The payment confirmation page has no navigation at all (Navigation renders nothing there).
export const useIsRailVisible = (isAuth?: boolean) => {
  const { pathname } = useLocation();
  const { lg } = useBreakpoint();

  const isPaymentConfirmedPage =
    getCompanyFreePath(ROUTES.PAYMENT_CONFIRMED) === getCompanyFreePath(pathname);

  return !!isAuth && lg && !isPaymentConfirmedPage;
};
